import i18n from '@/locales/i18n';
import Constants from '@/constants/Constants.js';
import { createNamespacedHelpers } from 'vuex';

const globalMapper = createNamespacedHelpers('global');
export default {
	name: 'MultipleLanguage',
	data() {
		return {
			languages: Constants.I18N_LANGUAGE,
		};
	},
	computed: {
		...globalMapper.mapState(['lang']),
	},

	mounted() {
		i18n.locale = this.lang;
	},
	methods: {
		...globalMapper.mapActions(['modifyLanguage']),
		modifyLocale(locale) {
			this.modifyLanguage({ lang: locale });
			i18n.locale = locale;
			this.$emit('on-change-language', locale);
		},
	},
};
